/* eslint-disable simple-import-sort/imports */
import React, { Component } from 'react';
import dayjs from 'dayjs';
import { NavLink } from 'react-router-dom';

import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

import { formatCurrency } from '@C/TableGrid';

import services from './data';
import './styles.scoped.scss';

class MiniDsr extends Component {
  constructor() {
    super();
    this.state = {
      time_stamp: dayjs().format('YYYY-MM-DD'),
      dsrData: [],
      loading: true,
      events: [],
      month: dayjs().format('MM'),
      year: dayjs().format('YYYY'),
    };
  }

  componentDidMount() {
    this.getDSR();
    this.getDSRDates();
  }

  getDSRDates = () => {
    services
      .getDSRDates(this.state.month, this.state.year)
      .then((response) => {
        const tmp = response.data.data;
        const eventsArr = [];
        tmp.forEach((item) => {
          eventsArr.push({
            date: item.time_stamp,
            display: 'background',
            classNames: item.lock_status ? 'locked' : 'unlocked',
          });
        });
        this.setState({ events: eventsArr }, function () {});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getDSR = () => {
    services
      .getDSRSummary(this.state.time_stamp)
      .then((response) => {
        this.setState({ dsrData: response.data.data, loading: false });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDate = (e) => {
    this.setState({ time_stamp: e.target.value, loading: true }, function () {
      this.getDSR();
    });
  };

  handleDateClick = (arg) => {
    this.setState(
      {
        time_stamp: dayjs(arg.event.start).format('YYYY-MM-DD'),
        loading: true,
      },
      function () {
        this.getDSR();
      },
    );
  };

  handleMonthChange = (arg) => {
    const month = arg.view.currentStart.getMonth() + 1;
    const year = arg.view.currentStart.getFullYear();
    this.setState({ month: month, year: year }, function () {
      this.getDSRDates();
    });
  };

  render() {
    const { events, dsrData } = this.state;

    return (
      <>
        <section className="widget dsr-table">
          <header>
            <div className="stock-info-header">
              <h3>DSR Summary</h3>
            </div>
          </header>
          <main className="two-col">
            <div className="col">
              <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]}
                events={events}
                datesSet={this.handleMonthChange}
                eventClick={this.handleDateClick}
                popperPlacement="bottom-start"
                height="auto"
                headerToolbar={{
                  left: 'prev',
                  center: 'title',
                  right: 'next',
                }}
              />
            </div>
            <div className="col">
              {(() => {
                if (this.state.loading) {
                  return <DropLoaderLarge />;
                } else {
                  return (
                    <div className="mini-dsr-container">
                      <div className="input-wrapper">
                        <NavLink
                          to={`/account/dsr/${this.state.time_stamp}`}
                          className="submit"
                        >
                          {`View DSR - ${dayjs(this.state.time_stamp).format('DD-MM-YYYY')}`}
                        </NavLink>
                      </div>
                      <ul className="data-list">
                        <li className="data-item">
                          <span>Opening Cash Balance</span>
                          <span>{formatCurrency(dsrData.opening_balance)}</span>
                        </li>
                        <li className="data-item">
                          <span>Total Sales</span>
                          <span>{formatCurrency(dsrData.total_sale)}</span>
                        </li>
                        <li className="data-item">
                          <span>Credit Sales</span>
                          <span>{formatCurrency(dsrData.credit_sale)}</span>
                        </li>
                        <li className="data-item">
                          <span>Other Expenses</span>
                          <span>{formatCurrency(dsrData.expenses)}</span>
                        </li>
                        <li className="data-item">
                          <span>Other Incomes</span>
                          <span>{formatCurrency(dsrData.other_income)}</span>
                        </li>
                        <li className="data-item">
                          <span>Fuel Purchases</span>
                          <span>{formatCurrency(dsrData.purchase)}</span>
                        </li>
                        <li className="data-item">
                          <span>Products Purchases</span>
                          <span>{formatCurrency(dsrData.lube_purchase)}</span>
                        </li>
                        <li className="data-item">
                          <span>Bank Deposit</span>
                          <span>{formatCurrency(dsrData.bank_deposit)}</span>
                        </li>
                        <li className="data-item">
                          <span>Closing Cash Balance</span>
                          <span>{formatCurrency(dsrData.closing_balance)}</span>
                        </li>
                        <li className="data-item">
                          <span>Total fuel sales</span>
                          <span>{formatCurrency(dsrData.fuel_sale)}</span>
                        </li>
                        <li className="data-item">
                          <span>Total Products sales</span>
                          <span>{formatCurrency(dsrData.lube_sale)}</span>
                        </li>
                      </ul>
                    </div>
                  );
                }
              })()}
            </div>
          </main>
        </section>
      </>
    );
  }
}

export { MiniDsr };
